// extracted by mini-css-extract-plugin
export default {"descriptionWrapper":"Description_descriptionWrapper__pmhdO"};